<template>
    <div class="skill-bar-wrapper">
        <div
            class="skill-bar"
            v-for="(skill, index) in skills"
            v-if="index < 3"
            @click="getForms(skill)"
            :key="skill.id">
            <div class="skill-bar-title-holder">
                <div class="skill-bar-title">{{ skill.name }}</div>
                <button
                    class="btn btn-open btn-show-details remove-icon-margin btn-primary-icon-only"
                    :title="$t('survey.view_details')"
                    type="button"></button>
            </div>
            <b-progress max="100">
                <b-progress-bar
                    :value="skill.self_value"
                    variant="primary"
                    :label="skill.self_value + '%'"></b-progress-bar>
            </b-progress>
            <b-progress
                class="skill-bar-result"
                max="100">
                <b-progress-bar
                    variant="success"
                    :value="skill.students_value"
                    :label="skill.students_value + '%'"></b-progress-bar>
            </b-progress>
            <b-progress
                class="skill-bar-result"
                max="100">
                <b-progress-bar
                    variant="warning"
                    :value="skill.teachers_value"
                    :label="skill.teachers_value + '%'"></b-progress-bar>
            </b-progress>
        </div>

        <b-collapse
            class="read-further"
            v-if="skills.length > 3"
            :id="`moreskills`">
            <div
                class="skill-bar"
                v-for="(skill, index) in skills"
                v-if="index > 2"
                @click="getForms(skill)"
                :key="skill.id">
                <div class="skill-bar-title-holder">
                    <div class="skill-bar-title">{{ skill.name }}</div>
                    <button
                        class="btn btn-open btn-show-details remove-icon-margin btn-primary-icon-only"
                        :title="$t('survey.view_details')"
                        type="button"></button>
                </div>
                <b-progress max="100">
                    <b-progress-bar
                        :value="skill.self_value"
                        variant="primary"
                        :label="skill.self_value + '%'"></b-progress-bar>
                </b-progress>
                <b-progress
                    class="skill-bar-result"
                    max="100">
                    <b-progress-bar
                        variant="success"
                        :value="skill.students_value"
                        :label="skill.students_value + '%'"></b-progress-bar>
                </b-progress>
                <b-progress
                    class="skill-bar-result"
                    max="100">
                    <b-progress-bar
                        variant="warning"
                        :value="skill.teachers_value"
                        :label="skill.teachers_value + '%'"></b-progress-bar>
                </b-progress>
            </div>

            <b-button
                class="btn-show-less btn-display-less"
                v-b-toggle="`moreskills`"
                variant="primary">
                {{ $t('survey.show_less') }}
            </b-button>
        </b-collapse>

        <b-button
            class="show-more btn-link-type btn-show-all btn-display-more"
            v-b-toggle="`moreskills`"
            v-if="skills.length > 3"
            variant="primary">
            {{ $t('survey.show_more') }}
        </b-button>

        <design-2021-survey-results-index-bars-modal-component
            ref="bars-details-modal"></design-2021-survey-results-index-bars-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-survey-results-index-bars-component',
    props: ['skillTreeIn'],
    methods: {
        getForms(skill) {
            this.$refs['bars-details-modal'].show(skill);
        },
    },
    computed: {
        skills() {
            return this.skillTreeIn.skills.map((skill) => {
                let self_value = null;
                let students_value = null;
                let teachers_value = null;

                for (const form of skill.forms) {
                    if (form.values !== undefined && form.values.self.value !== null && !self_value) {
                        self_value = form.values.self.value;
                    }
                    if (form.values !== undefined && form.values.students.value !== null && !students_value) {
                        students_value = form.values.students.value;
                    }
                    if (form.values !== undefined && form.values.teachers.value !== null && !teachers_value) {
                        teachers_value = form.values.teachers.value;
                    }

                    if (self_value && students_value && teachers_value) {
                        break;
                    }
                }

                return {
                    id: skill.id,
                    name: skill.name,
                    forms: skill.forms,
                    self_value: self_value,
                    students_value: students_value,
                    teachers_value: teachers_value,
                };
            });
        },
    },
};
</script>

<style scoped lang="scss">
.show-more.not-collapsed {
    display: none;
}

.skill-bar-result {
    margin-top: 5px;
}

.skill-bar {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.skill-bar:hover {
    cursor: pointer;
}

.skill-bar-title-holder {
    display: flex;
    justify-content: flex-start;
    align-content: center;
}

.skill-bar-title {
    align-self: center;
}

.btn-show-details {
    align-self: center;
    margin-left: auto;
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .skill-bar-wrapper,
    .read-further {
        display: flex;
        align-items: center;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;

        .skill-bar {
            width: calc(50% - 15px);
        }

        .btn-display-less,
        .btn-display-more {
            margin-left: auto;
            align-self: flex-end;
            margin-top: map-get($grid-gutter-spacing, 'fifteen');
        }
    }

    .read-further {
        width: 100%;
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .skill-bar-wrapper,
    .read-further {
        .skill-bar {
            width: 100%;
        }
    }
}
</style>
